import { BpResourcesProvider } from "./bpResources.provider";
import { failure, success } from "../shared";
import { ResourceFieldValues, ResourceName } from "./bpResources.types";

export enum BpResourcesErrorCode {
  GENERIC,
  LOAD_LOGO_FAILURE,
  UPDATE_RESOURCE_FAILURE,
  CHANGE_LOGO_FAILURE,
}

export class BpResourcesService {
  constructor(private bpResourcesProvider: BpResourcesProvider) {}

  public async getResourceDefinitions(subscriberId: string) {
    try {
      const data = await this.bpResourcesProvider.getResourceDefinitions(
        subscriberId
      );
      return success(data);
    } catch (error) {
      return failure(BpResourcesErrorCode.GENERIC);
    }
  }

  public async getLogo(subscriberId: string) {
    try {
      const { data } = await this.bpResourcesProvider.getLogo(subscriberId);
      return success(data);
    } catch (error) {
      return failure(BpResourcesErrorCode.LOAD_LOGO_FAILURE);
    }
  }

  public async getResource(subscriberId: string, resource: ResourceName) {
    try {
      const data = await this.bpResourcesProvider.getResource(
        subscriberId,
        resource
      );
      return success(data);
    } catch (error) {
      return failure(BpResourcesErrorCode.GENERIC);
    }
  }

  public async updateResource(
    subscriberId: string,
    resource: ResourceName,
    values: ResourceFieldValues
  ) {
    try {
      const data = await this.bpResourcesProvider.updateResource(
        subscriberId,
        resource,
        values
      );
      return success(data);
    } catch (error) {
      return failure(BpResourcesErrorCode.UPDATE_RESOURCE_FAILURE);
    }
  }

  public async updateLogo(subscriberId: string, logoObjectURL: string) {
    try {
      const data = await this.bpResourcesProvider.updateLogo(
        subscriberId,
        logoObjectURL
      );
      return success(data);
    } catch (error) {
      return failure(BpResourcesErrorCode.CHANGE_LOGO_FAILURE);
    }
  }

  public async getPreview(
    subscriberId: string,
    resource: ResourceName,
    values: ResourceFieldValues
  ) {
    try {
      const { data } = await this.bpResourcesProvider.getPreview(
        subscriberId,
        resource,
        values
      );
      return success(data);
    } catch (error) {
      return failure(BpResourcesErrorCode.GENERIC);
    }
  }
}
